(() => {
	const watched = new WeakSet();

	const dress = (host) => {
		const root = host.shadowRoot;
		if (!root) return false;
		if (root.querySelector('style[data-nd-font]')) return true;
		const style = document.createElement('style');
		style.setAttribute('data-nd-font', '');
		style.textContent = '* { font-family: inherit !important; }';
		root.appendChild(style);
		return true;
	};

	const watch = (host) => {
		if (watched.has(host)) return;
		watched.add(host);
		let tries = 0;
		const tick = () => {
			if (dress(host)) {
				new MutationObserver(() => dress(host)).observe(host.shadowRoot, { childList: true });
				return;
			}
			if (tries > 120) return;
			tries += 1;
			setTimeout(tick, 250);
		};
		tick();
	};

	const refresh = () => document.querySelectorAll('shopify-payment-terms').forEach(watch);

	refresh();
	new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
})();
